import React from 'react';
import Select from 'react-select';

const DropdownSelect = ({
  name,
  options,
  value,
  disabled,
  onChange,
  placeholder,
  valueKey = 'id',
  labelKey = 'name',
}) => {

  
  // Dynamically format options based on provided keys
  // const formattedOptions = options.map((opt) => ({
  //   value: opt[valueKey],
  //   label: opt[labelKey],
  // }));

  const formattedOptions = Array.isArray(options)
  ? options.map((opt) => ({
      value: opt[valueKey],
      label: opt[labelKey],
    }))
  : [];

  const selectedOption = formattedOptions.find((opt) => opt.value === value);

  return (
    <div className="select2" style={{ marginBottom: '16px' }}>
      {/* <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
        {label}
      </label> */}
      <Select
        options={formattedOptions}
        value={selectedOption}
        onChange={(selected) => onChange(name, selected ? selected.value : '')}
        placeholder={placeholder}
        isClearable
      />
    </div>
  );
};

export default DropdownSelect;
